import bluetech from '../img/bluetech.jpg'
import wago from '../img/wago-750-8212.jpg'
import bluetechibt from '../img/bluetechibt.jpg'
import pe200u from '../img/pe200u.png'
import sdc from '../img/EL-20-3050-32.png'


const api_data = {
  "all_products": [
    {
      company: 'Empresa 1',
      image: wago,
      titleImage: "PFC200 750-8212",
      titleItem: "Controlador WAGO 750-8212",
      licenca: '42x7xxxx-xxx86xx-x2x',
      tipo: "PiD",
      createdAt: "2020/06/17",
      expirate: "2021/09/21",
      hardware: "PFC200",
    },
    {
      company: 'Empresa 1',
      image: bluetechibt,
      titleImage: "BlueTech IBT 1800",
      titleItem: "MiniPC Bluetech IBT 1800",
      licenca: '42x7xxxx-xxx86xx-x2x',
      tipo: "PiD",
      createdAt: "2020/06/17",
      expirate: "2021/11/21",
      hardware: "Bwise IBT 1800",
    },
    {
      company: 'Empresa 3',
      image: sdc,
      titleImage: "EL-20-3050-32",
      titleItem: "EL-20-3050-32",
      licenca: '40xxxxx-xxxxxxx-xxx',
      tipo: "Historian",
      createdAt: "2019/04/19",
      expirate: "2021/01/21",
      hardware: "EL-20-3050-32",
    },
    {
      company: 'Empresa 4',
      image: bluetech,
      titleImage: "BlueTech IBT 1800",
      titleItem: "MiniPC Bluetech IBT 1800",
      licenca: '42xxxxx-xxxxxxx-xxx',
      tipo: "Historian",
      createdAt: "2019/04/19",
      expirate: "2021/11/26",
      hardware: "Bwise IBT 1800",
    },
    {
      company: 'Empresa 5',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '42xxxx34x-xxxxxxx-xxx',
      tipo: "Historian",
      createdAt: "2019/05/21",
      expirate: "2022/12/22",
      hardware: "PE200U",
    },
    {
      company: 'Empresa 5',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '412312xxx-xxxxxxx-xxx',
      tipo: "Historian",
      createdAt: "2020/06/17",
      expirate: "2021/12/22",
      hardware: "PE200U",
    },
    {
      company: 'Empresa 7',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '123467xx-xxxxxxx-xxx',
      tipo: "Historian",
      createdAt: "2018/03/17",
      expirate: "2021/12/22",
      hardware: "PE200U",
    },
    {
      company: 'Empresa 6',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '42x656x-xxxxxxx-xxx',
      tipo: "Historian",
      createdAt: "2010/02/04",
      expirate: "2021/12/22",
      hardware: "PE200U",
    },
    {
      company: 'Empresa 6',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '42x23xx-x867676xx-xxx',
      tipo: "Historian",
      createdAt: "2018/03/26",
      expirate: "2021/12/22",
      hardware: "PE200U",
    },
    {
      company: 'Empresa 5',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '42x7xxxx-xxx86xx-x2x',
      tipo: "PiD",
      createdAt: "2018/01/05",
      expirate: "2021/12/22",
      hardware: "PE200U",
    },
    {
      company: 'Empresa 8',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '42x7xx2x-xxx86xx-x2x',
      tipo: "Historian",
      createdAt: "2021/08/13",
      expirate: "2021/10/22",
      hardware: "PE200U",
    },
    {
      company: 'Empresa 8',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '42x7xxxx-xxx86xx-x2x',
      tipo: "Historian",
      createdAt: "2020/01/13",
      expirate: "2021/10/22",
      hardware: "PE200U",
    },
    {
      company: 'Empresa 11',
      image: pe200u,
      titleImage: "PE200U",
      titleItem: "MiniPC PE200U",
      licenca: '42x7xxxx-xxx86xx-x2x',
      tipo: "Historian",
      createdAt: "2019/06/13",
      expirate: "2021/10/22",
      hardware: "PE200U",
    },
  ],
  "historic": [
    {
      "sum_licensence_created_at": 30,
      "licenses_to_expirate": 10,
      "date": "2021-11"
    },
    {
      "sum_licensence_created_at": 20,
      "licenses_to_expirate": 10,
      "date": "2021-12"
    },
    {
      "sum_licensence_created_at": 25,
      "licenses_to_expirate": 20,
      "date": "2022-11"
    },
    {
      "sum_licensence_created_at": 16,
      "licenses_to_expirate": 22,
      "date": "2020-10"
    },
    {
      "sum_licensence_created_at": 33,
      "licenses_to_expirate": 13,
      "date": "2022-01"
    },
    {
      "sum_licensence_created_at": 5,
      "licenses_to_expirate": 20,
      "date": "2022-02"
    },
  ],
  "sum_company": [
    {
      company: 'Empresa 1',
      "sum_pid": 2,
      "sum_historian": 0,
      license: '33x7xxxx-xxx86xx-x2x',
    },
    {
      company: 'Empresa 3',
      "sum_pid": 0,
      "sum_historian": 1,
      license: '67x7xxxx-xxx86xx-x2x',
    },
    {
      company: 'Empresa 4',
      "sum_pid": 0,
      "sum_historian": 1,
      license: '42x739xx-xxx86xx-x2x',
    },
    {
      company: 'Empresa 5',
      "sum_pid": 1,
      "sum_historian": 2,
      license: '42x7x33x-xxx86xx-x2x',

    },
    {
      company: 'Empresa 6',
      "sum_pid": 0,
      "sum_historian": 2,
      license: '42x734xx-xxx86xx-x2x',

    },
    {
      company: 'Empresa 7',
      "sum_pid": 0,
      "sum_historian": 1,
      license: '42x7xxxx-xxx86xx-x2x',

    },
    {
      company: 'Empresa 8',
      "sum_pid": 0,
      "sum_historian": 2,
      license: '42x7xxxx-xx1236xx-x2x',

    },
    {
      company: 'Empresa 9',
      "sum_pid": 0,
      "sum_historian": 2,
      license: '42x7xxxx-xx1236xx-x2x',
    },
    {
      company: 'Empresa 10',
      "sum_pid": 0,
      "sum_historian": 2,
      license: '42x7xxxx-xx1236xx-x2x',

    },
    {
      company: 'Empresa 11',
      "sum_pid": 1,
      "sum_historian": 0,
      license: '47676789x-xxx86xx-x2x',
    },
  ],
  "ExpiratedLicense": [
    {
      name: 'Empresa 1',
      type: "T100-Historian-vitalicio",
      license: '42x7xxxx-xxx86xx-x2x',
      createdAt: "2020/06/17",
      expirate: "2021/09/21",
      hardware: 'Vinculado'
    },
    {
      name: 'Empresa 2',
      type: "T500-PiD-1ANO",
      license: '42x7xxxx-xxx86xx-x2x',
      createdAt: "2019/04/11",
      expirate: "2021/06/22",
      hardware: 'Não vinculado'


    },
    {
      name: 'Empresa 3',
      type: "T1000-Historian-2ANOS",
      license: '40xxxxx-xxxxxxx-xxx',
      createdAt: "2019/04/19",
      expirate: "2021/01/21",
      hardware: 'Não vinculado'


    },
    {
      name: 'Empresa 4',
      type: "T100-Historian-vitalicio",
      license: '42xxxxx-xxxxxxx-xxx',
      createdAt: "2019/04/19",
      expirate: "2021/11/26",
      hardware: 'Não vinculado'

    },
    {
      name: 'Empresa 5',
      type: "T100-PID-6MESES",
      license: '42xxxxx-22xxx41-xxx',
      createdAt: "2019/03/21",
      expirate: "2021/11/30",
      hardware: 'Vinculado'

    }
  ],
    "Demonstration": [
      {
        quantity: 2,
        "expirate": "2021-09-21",
      },{
        quantity: 3,
        "expirate": "2022-01-18",
      },{
        quantity: 4,
        expirate: "2021-06-29",
      },{
        quantity: 6,
        expirate: "2021-12-02",
      },{
        quantity: 8,
        expirate: "2021-11-22",
      },{
        quantity: 10,
        expirate: "2021-09-21",
      },
    ],
    "Hardware": [
      {
        image: wago,
        hardware: "PFC200",
        oficial: 'Sim',
        vinculado: 'Não',
        serialkEY: 'EAXHL15-2154SDA3-112'
      },
      {
        image: bluetech,
        hardware: "Bwise IBT 1800",
        oficial: 'Sim',
        vinculado: 'Sim',
        serialkEY: 'E12K1XC-2154SDA3-244567'
      },
      {
        image: sdc,
        hardware: "EL-20-3050-32",
        oficial: 'Sim',
        vinculado: 'Sim',
        serialkEY: 'E9EZHSRTTA9F-2154SDA3-112'
      },
      {     
        image: pe200u,
        hardware: "PE200U",
        oficial: 'Sim',
        vinculado: 'Não',
        serialkEY: 'HFCT23V1-91232142-44114'
      },
      {     
        hardware: "Intel Genérico 2",
        oficial: 'Não',
        vinculado: 'Sim',
        serialkEY: 'AG52V3-33561898-3345'
      }, 
      {     
        hardware: "AMD Genérico",
        oficial: 'Não',
        vinculado: 'Sim',
        serialkEY: 'A2BC36-6642323-23445'
      },
      {     
        hardware: "NVIDIA Genérico",
        oficial: 'Não',
        vinculado: 'Sim',
        serialkEY: 'E9E9F-9993432-45543'
      },
    ]
}
export default api_data